// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import DebitItem from '@deere/cps-it.warranty-model-factory/lib/partial-debit';
import DebitPartsPanelRowBody from './debit-parts-panel-row-body';
import DebitPartsPanelRowHeader from './debit-parts-panel-row-header';
import {FormattedMessage} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import {buildNumber} from '../../../../shared/services/build-number';

function handleAdjustmentValueChange(itemNumber, value) {

    this.actions.updateAdjustmentValue(itemNumber, value);

}

function handleAdjustmentTypeChange(itemNumber, type) {

    this.actions.updateAdjustmentType(itemNumber, type, this.adjustmentTypes);

}

const DebitPartsPanel = props =>
    props.parts.length > 0 &&
        <section className='debit-parts-panel'>
            <header className='debit-parts-panel-title'>
                <FormattedMessage
                    id='PARTS_WITH_COUNT'
                    values={{
                        count: buildNumber(props.parts.length)
                    }}
                />
            </header>
            <DebitPartsPanelRowHeader/>
            <section className='debit-parts-list'>
                {props.parts.map((part, index) =>
                    <DebitPartsPanelRowBody
                        adjustmentTypes={props.adjustmentTypes}
                        isEditable={props.isEditable}
                        key={index}
                        onAdjustmentTypeChange={handleAdjustmentTypeChange.bind(props, part.itemNumber)}
                        onAdjustmentValueChange={handleAdjustmentValueChange.bind(props, part.itemNumber)}
                        part={part}
                    />
                )}
            </section>
        </section>;

DebitPartsPanel.displayName = 'DebitPartsPanel';
DebitPartsPanel.propTypes = {
    actions: PropTypes.object,
    adjustmentTypes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)),
    isEditable: PropTypes.bool.isRequired,
    parts: PropTypes.arrayOf(PropTypes.instanceOf(DebitItem)).isRequired
};

export default DebitPartsPanel;



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/components/debit-parts-panel/debit-parts-panel.js